import React from 'react'
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import Home from '././component/home/Home';
import Expectation from './component/expectation/Expectation';
import Program from './component/program/Program';
import Gallary from './component/gallary/Gallary';
import Error from './component/404/Error';
import Nav from './component/nav/Nav';
import Footer from './component/footer/Footer';
import Contact from './component/contact/Contact';
import About from './component/about/About';
import Testimony from './component/testimony/Testimony';
import Founder from './component/founder/Founder';
import Give from './component/give/Give';

const Rout = () => {
  return (
    <div className='w-full'>
      
        <Router>
          {/* <Header/> */}
          <Nav/> 
            <Routes>
              
                <Route path='/' element={<Home/>} />
                <Route path='contact' element={<Contact/>}/>
                
                <Route path='expectation' element={<Expectation/>}/>
                <Route path='program' element={<Program/>}/>
                <Route path='gallary' element={<Gallary/>}/>
                <Route path='about' element={<About/>}/>
                <Route path='testimony' element={<Testimony/>}/>
                <Route path='founder' element={<Founder/>}/>
                <Route path='give' element={<Give/>}/>
                <Route path='*' element={<Error/>}/>
              
            </Routes> 
            {/* <Mailer/> */}
            <Footer/>
        </Router>
        
    </div>
  )
}

export default Rout;